import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Flex, themeGet } from '@lightspeed/flame/Core';
import { Modal, ModalHeader } from '@lightspeed/flame/Modal';
import { Text } from '@lightspeed/flame/Text';

const HubLabelPrintModalMaxWidth = '420px';

export const StyledFlex = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  background-color: ${themeGet('colors.bodyBg')};
  height: 145px;
  border-radius: ${themeGet('space.1')};
`;

export const StyledModal = styled(Modal)`
  width: ${HubLabelPrintModalMaxWidth};
  max-width: ${HubLabelPrintModalMaxWidth};
  max-height: 735px;
`;

export const StyledModalHeader = styled(ModalHeader)`
  max-width: 100%;
  > * {
    max-width: 100%;
  }
`;

export const StyledText = styled(Text)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: calc(0.8 * ${HubLabelPrintModalMaxWidth});
`;

export const StyledLabel = styled(Text)`
  margin-bottom: ${themeGet('space.1')};
  line-height: ${themeGet('space.3')};
  font-weight: bold;
  font-size: 0.875rem;
`;

export const StyledLabelWithoutMargin = styled(StyledLabel)`
  margin-bottom: 0px;
`;

export const StyledDescription = styled(Text)`
  color: ${themeGet('colors.textDimmed')};
  font-size: ${themeGet('space.2')};
`;

export const UnstyledButton = styled(Button)`
  background: none;
  background-image: none;
  outline: none;
  border: none;
  box-shadow: none;
  padding: 0;
  color: ${themeGet('colors.blue-500')};
  min-height: 0;
  text-decoration: none;

  &:focus,
  &:hover,
  &:active {
    color: ${themeGet('colors.blue-500')};
    background: none;
    background-image: none;
    outline: none;
    border: none;
    box-shadow: none;
    text-decoration: underline;
  }
`;

export const BarcodeDisplayOptionsLabel = styled('label')`
  margin: 0;
  font-weight: 700;
  color: ${themeGet('colors.gray-1000')};
  font-size: ${themeGet('fontSizes.text-s')};

  &.disabled {
    color: ${themeGet('colors.disabled')};
  }
`;

export const DescriptionText = styled(Text)`
  color: ${themeGet('colors.gray-600')};
  font-size: ${themeGet('fontSizes.text-xs')};
  margin-bottom: ${themeGet('space.1')};
`;
